import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetListGuideGrievanceNotificationToCardPageRequest } from '../../requests/orchestrator-patient/get-list-guide-grievance-notification-to-card-page.request';
import { CreateUpdateGuideGrievanceNotificationRequest } from '../../requests/hospital-document/create-update-guide-grievance-notification.request';
import { GuideGrievanceNotificationReportResponse } from '../../responses/hospital-document/guide-grievance-notification-report.response';
import { GuideGrievanceNotificationToCardPageResponse } from '../../responses/orchestrator-patient/guide-grievance-notificationto-card-page.response';
import { GetGrievanceNotificationToTriageSupplementaryDataPageResponse } from '../../responses/orchestrator-patient/get-grievance-notification-to-triage-supplementary-data-page.response';
import { GetGuideGrievanceNotificationToRegisterPageResponse } from '../../responses/hospital-document/get-guide-grievance-notification-to-register-page.response';

@Injectable({
  providedIn: 'root'
})
export class GuideGrievanceNotificationService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getGrievanceNotificationToRegister(idGuideGrievanceNotification: number, idEpisode: number, idModule: number): Observable<GetGuideGrievanceNotificationToRegisterPageResponse> {
    let uri = `GuideGrievanceNotification/GetGuideGrievanceNotificationToRegisterPage/idGuideGrievanceNotification/${idGuideGrievanceNotification}/idEpisode/${idEpisode}/idModule/${idModule}`;

    return this.httpClient.get<GetGuideGrievanceNotificationToRegisterPageResponse>(environment.urlApiOrchestratorPatient + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getGrievanceNotification(idEpisode: number): Observable<GetGrievanceNotificationToTriageSupplementaryDataPageResponse> {
    let uri = `GuideGrievanceNotification/GetGrievanceNotification?`;

    if(idEpisode)
      uri += `idEpisode=${idEpisode}`;

    return this.httpClient.get<GetGrievanceNotificationToTriageSupplementaryDataPageResponse>(environment.urlApiOrchestratorPatient + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getPaginatedGrievanceNotifications(request: GetListGuideGrievanceNotificationToCardPageRequest): Observable<GuideGrievanceNotificationToCardPageResponse> {
    let uri = `GuideGrievanceNotification/GetPaginatedGuideGrievanceNotifications`;

    return this.httpClient.post<GuideGrievanceNotificationToCardPageResponse>(environment.urlApiOrchestratorPatient + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public updateGuideGrievanceNotification(request: CreateUpdateGuideGrievanceNotificationRequest): Observable<GuideGrievanceNotificationReportResponse> {
    let uri = `GuideGrievanceNotification/UpdateGuideGrievanceNotification`;

    return this.httpClient.put<GuideGrievanceNotificationReportResponse>(environment.urlApiOrchestratorPatient + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}